import React, { ReactNode } from 'react'
import { css } from 'src/style/css'
import { Theme } from 'src/style/Theme'
import MaxWidthContainer from 'src/components/MaxWidthContainer'

type ContainerProps = {
    children: ReactNode
    className?: string
}

const Container = ({ children, className, ...props }: ContainerProps) => (
    <MaxWidthContainer
        {...props}
        css={(th: Theme) => css`
            padding-top: ${th.spacing.xl};
            padding-bottom: ${th.spacing.xl};
            > *:not(:last-child) {
                margin-bottom: ${th.spacing.containerDivider};
            }
        `}
        className={className}
    >
        {children}
    </MaxWidthContainer>
)

export default Container
